export enum CustomerStatusEnum {
  Active = 1,
  Suspended = 2,
  Deleted = 3,
  Archived = 4,
  Rejected = 5,
  Pending = 6,
}

export enum CustomerStatus {
  Active = 1,
  Suspended = 2,
  Deleted = 3,
  Archived = 4,
  Rejected = 5,
  Pending = 6,
  All = 7,
}
